import { EVariableIncomeWithdrawSteps } from './types';
import { Conclusion, Preview, Withdraw } from '../components';

export const VariableIncomeWithdrawComponents = {
  [EVariableIncomeWithdrawSteps.INVESTMENT]: Withdraw,
  [EVariableIncomeWithdrawSteps.PREVIEW]: Preview,
  [EVariableIncomeWithdrawSteps.CONCLUSION]: Conclusion
};
